 

import styled from "styled-components";

export const Icon = styled.button.attrs((props) => ({
  type: props.type || "button",
}))`
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  border-radius: 2.6px;
  outline: none;
  border: none;
  background: ${({ active, bg }) => (active ? "#eaeaea" : bg || "none")};
  &:hover {
    background: #eaeaea;
  }
  &:disabled {
    opacity: 0.3;
  }
  &:is(:disabled :hover) {
    background: none;
  }
`;
